import BaseRichContentPage from './BaseRichContentPage';

class CountryPage extends BaseRichContentPage {
	loadContent() {
		import(
			/* webpackChunkName: "CountryPageContent" */
			'../components/CountryPageContent'
			)
			.then(({'default': CountryPageContent}) => {
				new CountryPageContent(window.richContentPageParams);
			});
	}
}

new CountryPage();